module.exports = __webpack_public_path__ + "ca6a95b4f38431617a5702f93b65f0a7.ttf";